import Utils from '../utils.js';

let page = 1;
let loading = false;
let allLoaded = false;

const observer = new IntersectionObserver(entries => {
	const entry = entries[0];
	if (entry.isIntersecting && !loading && !allLoaded) {
		loading = true;

		page++;

		fetch(`${quick_news_scroll.ajax_url}?action=load_more_quick_news&page=${page}`)
			.then(res => res.text())
			.then(html => {

				if (html.trim().length === 0) {
					allLoaded = true;
					observer.unobserve(entry.target);
					return;
				}

				const container = document.getElementById('quick-news-posts');
				const tempWrapper = document.createElement('div');
				tempWrapper.innerHTML = html;

				tempWrapper.querySelectorAll('.quick-news-archive__post').forEach(post => {
					post.classList.add('just-added');
					container.appendChild(post);
				});

				const newPosts = container.querySelectorAll('.quick-news-archive__post.just-added');

				newPosts.forEach(post => {
					const timestamps = post.querySelectorAll('.time-to-relative');
					timestamps.forEach(el => {
						const time = el.dataset.timestamp || 0;
						const relativeTime = Utils.getRelativeTimestamp(time) || "";
						el.textContent = relativeTime;
					});

					const body = post.querySelector('.quick-news-single__body-text');
					if (body) {
						Utils.makeItemCollapsibleByWords(body, 60);
					}

					post.classList.remove('just-added');
				});

				// Dispatch event for other modules
				document.dispatchEvent(new CustomEvent('touchit:postsLoaded'));

				loading = false;
			})
			.catch(err => {
				console.error('Loading error:', err);
				loading = false;
			});
	}
}, {
	rootMargin: '200px',
});

const sentinel = document.getElementById('infinite-scroll-sentinel');
if (sentinel) {
	observer.observe(sentinel);
}